/**
 * Asynchronously loads the component for Site Details Page
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
